import { create } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';

interface ToasterState {
  isVisible: boolean;
  message: string;
  type: 'success' | 'error' | 'info';
  duration: number;
  showToaster: (message: string, type?: 'success' | 'error' | 'info', duration?: number) => void;
  hideToaster: () => void;
}

export const useToasterStore = create<ToasterState>()(devtools(
  subscribeWithSelector((set) => ({
    isVisible: false,
    message: '',
    type: 'success',
    duration: 3000,
    showToaster: (message: string, type: 'success' | 'error' | 'info' = 'success', duration: number = 3000) => {
      set({ isVisible: true, message, type, duration });
    },
    hideToaster: () => {
      set({ isVisible: false });
    },
  })),
  {
    name: 'ToasterStore',
    enabled: process.env.NODE_ENV === 'development'
  }
)); 